import React from "react";
import PropTypes from "prop-types";
import { Row, Radio, Space } from "antd";
import { generateMonthDates } from "../../../utils/report";

export const DateOfMonth = (props) => {
  const { value, onChange, reportType, month } = props;
  return (
    <>
      <Row justify="center">
        <Radio.Group value={value} buttonStyle="solid" onChange={onChange}>
          <Space direction="vertical">
            {generateMonthDates(reportType, month)}
            {props.children}
          </Space>
        </Radio.Group>
      </Row>
    </>
  );
};

DateOfMonth.propTypes = {};

export default DateOfMonth;
